import TagItem from "./tag-item";
import "./tag-list.sass";

type Props = {
  tagList: string[];
};
const TagList = ({ tagList }: Props) => {
  return (
    <div className="tag-list">
      {tagList.map((tag, idx) => (
        <TagItem tagTitle={tag} key={tag + "-" + idx} />
      ))}
    </div>
  );
};

export default TagList;
